import { TrussRequest } from '../../types';

/**
 * Base properties for building a TrussRequest
 */
interface TrussRequestBase {
  id: number;
  orderDate: string;
  sizeFeet: number;
  sizeInches: number;
  quantity: number;
  measurementInsidePost: number;
  confirmedMeasurementInsidePost: boolean;
  carriageBolts: boolean;
  notes?: string;
  price: number;
}

/**
 * Builds a TrussRequest for Gable truss
 */
export const buildGableTrussRequest = (
  base: TrussRequestBase,
  classification: string,
  roofPitch: string,
  overhangType: 'Standard' | 'Custom',
  overhangSize?: number
): TrussRequest => {
  return {
    id: base.id,
    productType: 'Gable',
    classification,
    orderDate: base.orderDate,
    sizeFeet: base.sizeFeet,
    sizeInches: base.sizeInches,
    quantity: base.quantity,
    measurementInsidePost: base.measurementInsidePost,
    confirmedMeasurementInsidePost: base.confirmedMeasurementInsidePost,
    roofPitch,
    overhangType,
    overhangSize: overhangType === 'Custom' ? overhangSize : undefined,
    carriageBolts: base.carriageBolts,
    notes: base.notes,
    price: base.price,
  };
};

/**
 * Builds a TrussRequest for Header truss
 */
export const buildHeaderTrussRequest = (base: TrussRequestBase): TrussRequest => {
  return {
    id: base.id,
    productType: 'Header',
    classification: '', // Header trusses don't have classification
    orderDate: base.orderDate,
    sizeFeet: base.sizeFeet,
    sizeInches: base.sizeInches,
    quantity: base.quantity,
    measurementInsidePost: base.measurementInsidePost,
    confirmedMeasurementInsidePost: base.confirmedMeasurementInsidePost,
    carriageBolts: base.carriageBolts,
    notes: base.notes,
    price: base.price,
  };
};

/**
 * Builds a TrussRequest for LeanTo truss
 */
export const buildLeanToTrussRequest = (
  base: TrussRequestBase,
  classification: string,
  roofPitch: string,
  overhangType: 'Standard' | 'Custom',
  overhangSize?: number,
  monoslopeTruss?: boolean,
  postSizeOverride?: boolean,
  postSizeOverrideValue?: string | null,
  connectToHeaderTruss?: boolean
): TrussRequest => {
  return {
    id: base.id,
    productType: 'LeanTo',
    classification,
    orderDate: base.orderDate,
    sizeFeet: base.sizeFeet,
    sizeInches: base.sizeInches,
    quantity: base.quantity,
    measurementInsidePost: base.measurementInsidePost,
    confirmedMeasurementInsidePost: base.confirmedMeasurementInsidePost,
    roofPitch,
    overhangType,
    overhangSize: overhangType === 'Custom' ? overhangSize : undefined,
    carriageBolts: base.carriageBolts,
    notes: base.notes,
    monoslopeTruss,
    postSizeOverride,
    postSizeOverrideValue: postSizeOverrideValue ?? undefined,
    connectToHeaderTruss,
    price: base.price,
  };
};
